import type { PaymentsGateway } from './PaymentsGateway';
import type { PaymentBatchResponse, PaymentTransactionResponse, PayrollRunSummary } from './types';

const MOCK_RUN: PayrollRunSummary = {
  id: 'mock-payroll-run-1', status: 'Approved', checkDate: '2026-03-16', periodStartDate: '2026-03-01', periodEndDate: '2026-03-14',
};

const SEEDED_BATCH: PaymentBatchResponse = {
  id: 'mock-batch-1', companyId: 'mock-company', payrollRunId: MOCK_RUN.id, status: 'Settled',
  providerFileId: 'MOCK-ACH-FILE-1', failureReason: null, initiatedByEmailSnapshot: 'admin@epn.local',
  initiatedAtUtc: '2026-03-16T10:00:00.000Z', submittedAtUtc: '2026-03-16T10:05:00.000Z',
  settledAtUtc: '2026-03-17T09:00:00.000Z', failedAtUtc: null,
};

/** Local-development-only in-memory stand-in — the production build (VITE_USE_MOCKS=false, the default
 * in .env) always uses HttpPaymentsGateway against the real EPN.PaymentProcessing.Api. Seeds one
 * already-settled batch for `MOCK_RUN` — reports (EPN-77) must read existing history, never trigger a new
 * batch themselves, so the mock needs realistic pre-existing data rather than starting empty. */
export class MockPaymentsGateway implements PaymentsGateway {
  private batches: PaymentBatchResponse[] = [SEEDED_BATCH];

  async listApprovedPayrollRuns(): Promise<PayrollRunSummary[]> { return [MOCK_RUN]; }

  async listBatchesForRun(payrollRunId: string): Promise<PaymentBatchResponse[]> {
    return this.batches.filter((b) => b.payrollRunId === payrollRunId);
  }

  async initiateBatch(payrollRunId: string): Promise<PaymentBatchResponse> {
    const batch: PaymentBatchResponse = {
      id: `mock-batch-${this.batches.length + 1}`, companyId: 'mock-company', payrollRunId, status: 'Submitted',
      providerFileId: null, failureReason: null, initiatedByEmailSnapshot: 'admin@epn.local',
      initiatedAtUtc: new Date().toISOString(), submittedAtUtc: new Date().toISOString(), settledAtUtc: null, failedAtUtc: null,
    };
    this.batches.push(batch);
    return batch;
  }

  async listTransactions(batchId: string): Promise<PaymentTransactionResponse[]> {
    if (batchId !== SEEDED_BATCH.id) return [];
    return [{ id: 'mock-txn-1', paymentBatchId: batchId, payrollCalculationId: 'mock-calc-1', employeeId: 'mock-employee-1', amount: 800 }];
  }

  async checkBatchStatus(id: string): Promise<PaymentBatchResponse> {
    const batch = this.batches.find((b) => b.id === id)!;
    batch.status = 'Settled';
    batch.settledAtUtc = new Date().toISOString();
    return batch;
  }
}
